import { CopyOutlined } from '@ant-design/icons'
import { Button, message, QRCode, Skeleton } from 'antd'
import BackButton from 'components/BackButton'
import { addCommasToNumber } from 'helpers'
import { useEffect, useState } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { useParams } from 'react-router-dom'
import handle from 'services/Axios'
import SWR_KEY from 'services/swr/constant'
import { useGetTokenWallet } from 'services/swr/token'
import useTranslation from 'translations/useTranslation'
import { formatCode, formatUnits } from 'utils'

const DepositDetailPage = () => {
  const { t } = useTranslation()
  const { id } = useParams()

  const { data, mutate } = useGetTokenWallet()

  const [tokenData, setTokenData] = useState<any>()
  const [loading, setLoading] = useState(false)

  const handleSync = async () => {
    let url = SWR_KEY.SYNC_BSC
    if (tokenData.chain.code === 'TRX') url = SWR_KEY.SYNC_TRX

    try {
      setLoading(true)

      const res = await handle.get(url)
      if (res.data.status === 200) await mutate()
    } catch (error) {
      console.log('🚀 ~ handleSync ~ error:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (!data || !id) return
    setTokenData(data.find((t) => t.id === +id))
  }, [data, id])

  return (
    <div className='flex flex-col gap-5'>
      <BackButton title={t('deposit')} />

      {!tokenData ? (
        <Skeleton.Node active className='!w-full !h-[70vh]' />
      ) : (
        <div className='flex flex-col items-center gap-4'>
          <QRCode className='!w-48 !h-48' value={tokenData.wallet_deposit} />

          <div className='flex flex-col gap-2'>
            <p className='text-center text-lg'>{t('walletAddress')}</p>
            <CopyToClipboard onCopy={() => message.success(t('Copied success'))} text={tokenData.wallet_deposit}>
              <p className='text-secondary text-center text-base flex items-center justify-center cursor-pointer'>
                <p className='text-center '>{formatCode(tokenData.wallet_deposit, 12, 12)}</p>
                <CopyOutlined className='ml-1' />
              </p>
            </CopyToClipboard>
          </div>

          <p className='text-center text-lg'>
            {t('currentBalance')}: {addCommasToNumber(formatUnits(tokenData.balance, +tokenData.decimals))} {tokenData.symbol}
          </p>

          <Button
            type='primary'
            size='large'
            className='min-h-10 w-full'
            disabled={!tokenData}
            onClick={handleSync}
            loading={loading}
          >
            {t('rechargeCompleted')}
          </Button>

          <div className='flex flex-col gap-2'>
            <p className='text-center'>{t('description')}</p>
            <p className='text-center text-red-600'>{t('pressRechargeCompleteNote')}</p>
          </div>
        </div>
      )}
    </div>
  )
}

export default DepositDetailPage
